// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__254U9","header":"MergedInvoice_header__37TR1"};